module.exports = __webpack_public_path__ + "static/crypto-wallet-4e2c820c3f6187b3ce6124b776e1fa66.png";